import {
  faWeightScale,
  faWaveSquare,
  faSpa,
  faFireFlameCurved,
  faSun,
  faClock,
  faTooth,
  faImages,
  faHeartPulse,
  faSyringe,
  faStar,
  faSeedling,
  faDroplet,
  faShieldHeart,
} from "@fortawesome/free-solid-svg-icons";

export const slimmingLink = [
  {
    path: "/services/slimming/slimming-weight-management",
    title: "Slimming & Weight Management",
    description:
      "Personalized weight loss programs with proven results through scientific methods and lifestyle guidance.",
    icon: faWeightScale,
  },
  {
    path: "/services/slimming/hifu-body",
    title: "HIFU for Body",
    description:
      "Non-invasive body contouring and skin tightening using High-Intensity Focused Ultrasound technology.",
    icon: faWaveSquare,
  },
];

export const skincareLinks = [
  {
    path: "/services/skin-care/beauty-facials",
    title: "Beauty Facials",
    description:
      "Rejuvenating facials tailored to your skin type for radiant, glowing complexion and deep nourishment.",
    icon: faSpa,
  },
  {
    path: "/services/skin-care/acne-scar-reduction",
    title: "Acne & Scar Reduction",
    description:
      "Advanced treatments to clear active acne and reduce scarring for smooth, blemish-free skin.",
    icon: faFireFlameCurved,
  },
  {
    path: "/services/skin-care/pigmentation-tanning",
    title: "Pigmentation & Tanning",
    description:
      "Effective solutions for uneven skin tone, dark spots, and sun damage for uniform complexion.",
    icon: faSun,
  },
  {
    path: "/services/skin-care/anti-aging-treatments",
    title: "Anti-Aging Treatments",
    description:
      "Youthful rejuvenation therapies to reduce wrinkles, fine lines, and restore skin elasticity.",
    icon: faClock,
  },
  {
    path: "/services/skin-care/laser-hair-removal",
    title: "Laser Hair Removal",
    description:
      "Permanent hair reduction with advanced laser technology for smooth, hair-free skin.",
    icon: faDroplet,
  },
];

export const haircareLinks = [
  {
    path: "/services/hair-care/hair-care-restoration ",
    title: "Hair Care & Restoration",
    description:
      "Comprehensive solutions for hair fall, thinning, and regrowth with proven clinical treatments.",
    icon: faDroplet,
  },
  {
    path: "/services/hair-care/prp-hair-therapy",
    title: "PRP Hair Therapy",
    description:
      "Natural hair regrowth treatment using your own platelet-rich plasma for thicker, healthier hair.",
    icon: faSyringe,
  },
  {
    path: "/services/hair-care/hair-transplant",
    title: "Hair Transplant",
    description:
      "Advanced surgical solutions for permanent hair restoration and natural-looking results.",
    icon: faSeedling,
  },
];

export const dentalLinks = [
  {
    path: "/services/dental-care/dental-whitening",
    title: "Teeth Whitening",
    description:
      "Professional teeth whitening treatments for a brighter, more confident smile instantly.",
    icon: faStar,
  },
  {
    path: "/services/dental-care/dental-implants",
    title: "Dental Implants",
    description:
      "Permanent tooth replacement solutions that look, feel, and function like natural teeth.",
    icon: faTooth,
  },
  {
    path: "/services/dental-care/routine-dental-care",
    title: "Routine Dental Care",
    description:
      "Comprehensive dental checkups, cleaning, and preventive care for optimal oral health.",
    icon: faShieldHeart,
  },
];

export const aboutLinks = [
  {
    path: "/gallery",
    title: "Gallery",
    description:
      "View our before-after transformations and clinic facilities through our photo gallery.",
    icon: faImages,
  },
  {
    path: "/aboutus",
    title: "About Us",
    description:
      "Learn about our mission, team, and commitment to your wellness journey.",
    icon: faHeartPulse,
  },
  {
    path: "/testimonials",
    title: "Testimonials",
    description:
      "Read success stories and experiences from our satisfied patients.",
    icon: faStar,
  },
];
